import { CustomerDocument, useCustomerQuery } from '@graphcommerce/magento-customer'
import { TabPanel } from '@mui/lab'
import { Paper, Tab, Tabs, styled } from '@mui/material'
import Head from 'next/head'
import { MutableRefObject } from 'react'
import { ProductReviews } from './ProductReviews'

export type ProductsReviewsQATabsProps = {
  productId: number | null | undefined
  productTitle: string | null | undefined
  productUrl: string | null | undefined
  sectionRef: MutableRefObject<any>
  bottomLineData: any
  productDescription: any
  productImages: any[]
  qaData: any[]
}
export interface StyledTabsProps {
  children?: React.ReactNode
  value: string
  onChange: (event: React.SyntheticEvent, newValue: string) => void
}

export const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs {...props} TabIndicatorProps={{ children: <span className='MuiTabs-indicatorSpan' /> }} />
))(({ theme }) => ({
  minHeight: 35,
  height: 35,
  marginTop: 20,
  [theme.breakpoints.up('md')]: {
    minHeight: 40,
    height: 40,
  },
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    height: 4,
  },
  '& .MuiTabs-indicatorSpan': {
    width: '100%',
    backgroundColor: '#60269E',
  },
}))

export interface StyledTabProps {
  label: string
  id: string
  value: string
  'aria-controls': string
}

export const StyledTab = styled((props: StyledTabProps) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    minWidth: 0,
    minHeight: 35,
    height: 35,
    paddingRight: 0,
    paddingLeft: 0,
    marginRight: '10%',
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.up('md')]: {
      minHeight: 40,
      height: 40,
      marginRight: '7%',
      fontSize: theme.typography.pxToRem(24),
    },
    color: '#967BB4',
    '&.Mui-selected': {
      color: '#60269E',
      fontWeight: 'bold',
    },
    '&.Mui-focusVisible': {
      backgroundColor: '#60269E',
    },
  }),
)

export interface StyledTabPanelProps {
  value: string
  children?: React.ReactNode
}

export const StyledTabPanel = styled((props: StyledTabPanelProps) => <TabPanel {...props} />)(
  ({ theme }) => ({
    '&.MuiTabPanel-root': {
      paddingLeft: 0,
      paddingRight: 0,
    },
  }),
)
export function ProductsReviewsQATabs(props: ProductsReviewsQATabsProps) {
  const dashboard = useCustomerQuery(CustomerDocument, {
    fetchPolicy: 'cache-and-network',
  })
  const customer = dashboard.data?.customer

  return (
    <div>
      <div className='mb-5' ref={props?.sectionRef}>
        <ProductReviews customer={customer} {...props} />
      </div>
    </div>
  )
}
